// Public support contacts (WhatsApp confirmed public by Zerayacob, 31 Oct 2026; same number as the app's
// lul/lib/utils/constants/support_contacts.dart). The display strings appear verbatim in every locale.
export const SUPPORT_EMAIL = 'support@lulpay.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const WHATSAPP_DISPLAY = '+256 709 413 576';
export const WHATSAPP_URL = 'https://wa.me/256709413576';

/** Account deletion is explained in the privacy policy, section "Data-deletion requests". */
export const DELETION_PATH = '/privacy#data-deletion';
